import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { TextBox, TextBoxProps } from "./textBox";
import React from "react"
export class EmailTextBox extends React.Component<EmailTextBoxProps, EmailTextBoxState>{

    private _ref: any;
    constructor(props: TextBoxProps) {
        super(props);
        this.state = {
            value: this.sanitizeInput(props.value)
        };
    }

    private sanitizeInput = (value: string): string => {
        if (Helper.hasValue(value)) {
            return String(value).replace(/\0/g, '');
        } else {
            return null;
        }
    }


    componentDidUpdate(lastProps: TextBoxProps) {
        //console.log("componentDidUpdate")
        const sanitized = this.sanitizeInput(this.props.value);
        if ((lastProps.value || "").toString() != (sanitized || "").toString()) {
            this._ref.inputRef.value = sanitized;
            this.setState({ value: sanitized })
        }
    }

    handleChange = (_e: any) => {
        //console.log("handleChange")
        if (this.props.field.triggerOnChange) {
            this.props.onChange(this.props.field, this.sanitizeInput(_e.target.value), null);
        } else {
            this.setState({ value: this.sanitizeInput(_e.target.value) });
        }
    }
    handleBlur = (_e: any) => {
        if (!this.props.field.triggerOnChange && this.props.value != this.state.value)
            this.props.onChange(this.props.field, this.sanitizeInput(this.state.value), null);
    }

    handleFocus = (_e: any) => {
        if (!(typeof (this.props.onFocus) == 'undefined')) {
            this.props.onFocus(_e);
        }
    }
    render() {
        if (this.props.disabled)
            return <TextBox {...this.props} />
        return <TelerikEmailTextBox ref={(r) => this._ref = r} {...this.props} />;
    }
}

export class TelerikEmailTextBox extends React.Component<EmailTextBoxProps, {}>{
    private inputRef: HTMLElement;
    private readonly name: string;
    protected _textbox: kendo.ui.TextBox;
    constructor(props: EmailTextBoxProps) {
        super(props)
        this.name = this.props.field.name;
        this.name = Helper.isNullOrEmpty(this.name) || this.name == "n/a" ? kendo.guid() : this.name;
    }

    componentDidMount() {
        this._textbox = $(this.inputRef).kendoTextBox({
            value: (this.props.value || ""),
            readonly: this.props.disabled,
            placeholder: (this.props.field.placeholder || ""),
            change: (ev) => {
                let value = ev.sender.value();
                this.props.onChange(this.props.field, value, null)
            }
        }).data("kendoTextBox");
    }
    render() {
        return (
            <>
                <input
                    autoFocus={this.props.field.focus}
                    name={this.props.field.model}
                    style={{ width: "100%" }}
                    data-label={this.name}
                    required={this.props.required}
                    ref={(ref) => { this.inputRef = ref; }}
                    readOnly={this.props.disabled}
                    type={"email"}
                    placeholder={Helper.isNullOrEmpty(this.props.field.placeholder) ? "" : this.props.field.placeholder}
                />
            </>)
    }

}
export interface EmailTextBoxProps extends BaseComponentProps {
    field: EmailTextBoxField;
    onFocus?(e: any);
    onKeyPress?(e: React.KeyboardEvent<HTMLElement>);
    onKeyDown?(e: React.KeyboardEvent<HTMLElement>);
}

interface EmailTextBoxField extends BaseField {
    triggerOnChange?: boolean;
    placeholder?: string;
    focus?: boolean;
}

interface EmailTextBoxState {
    value: any;
}